import { styled } from "@mui/material";

export const Div = styled("div")(() => ({
  [`& span`]: {
    color: "rgba(170, 170, 170)",
    fontSize: "0.98rem",
    letterSpacing: "0.00938em",
  },
}));
